"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
var Radio_1 = __importDefault(require("@mui/material/Radio"));
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var Lang_js_1 = require("../Lang.js");
var dateUtils_js_1 = require("./dateUtils.js");
function formatDate(dateString) {
    return (0, dateUtils_js_1.toIsoDate)(dateString);
}
function FeePaymentStatus(_a) {
    var _b;
    var renewal = _a.renewal, showOtherDescription = _a.showOtherDescription, setShowOtherDescription = _a.setShowOtherDescription, handleChange = _a.handleChange;
    var locale = document.documentElement.lang || 'en';
    var handleRadioChange = function (e) {
        handleChange(e);
        if (e.target.value === 'other') {
            setShowOtherDescription(true);
        }
        else {
            setShowOtherDescription(false);
        }
    };
    return (react_1.default.createElement("div", { className: "form-group button-status" },
        react_1.default.createElement("h3", { className: "section-title" },
            (0, Lang_js_1.__)('Fee payment status'),
            ":"),
        renewal.fee_payment_status !== 'OK' ? (react_1.default.createElement("div", { className: "renewal-section" },
            react_1.default.createElement("div", { className: "alert-message" }, (0, Lang_js_1.__)('We do not have a record that you have paid a ministerial fee within the last 90 days.')),
            react_1.default.createElement(Button_1.default, { variant: "contained", className: "alert-button", onClick: function (e) { e.preventDefault(); var modal = document.getElementById('renewal_payment_modal'); if (modal)
                    modal.style.display = 'block'; } }, (0, Lang_js_1.__)('Please click here to pay your ministerial renewal fee before submitting your application')),
            react_1.default.createElement("p", null, (0, Lang_js_1.__)('If you are currently not able to pay your credential renewal fee, you can still submit your application to avoid a late charge, but please contact us at minboard@msia.org.')),
            react_1.default.createElement("div", { className: "payment-options" },
                react_1.default.createElement("p", null,
                    (0, Lang_js_1.__)('If you have paid recently or are using an alternative method, you can enter details here'),
                    ":"),
                react_1.default.createElement(RadioGroup_1.default, { name: "fee_payment_method", onChange: handleRadioChange },
                    react_1.default.createElement(FormControlLabel_1.default, { value: "paid_online", control: react_1.default.createElement(Radio_1.default, null), label: (0, Lang_js_1.__)('Paid Online') }),
                    !(locale === 'es' || locale === 'pt') && (react_1.default.createElement(FormControlLabel_1.default, { value: "check", control: react_1.default.createElement(Radio_1.default, null), label: (0, Lang_js_1.__)('Check') })),
                    react_1.default.createElement(FormControlLabel_1.default, { value: "other", control: react_1.default.createElement(Radio_1.default, null), label: (0, Lang_js_1.__)('Other') })),
                showOtherDescription && (react_1.default.createElement(TextField_1.default, { name: "fee_payment_method_other_description", placeholder: (0, Lang_js_1.__)('Other: please describe'), value: renewal.fee_payment_method_other_description || '', onChange: handleChange, size: "small", variant: "outlined", fullWidth: true })),
                react_1.default.createElement(TextField_1.default, { name: "fee_payment_amount", placeholder: (0, Lang_js_1.__)('Payment amount'), value: renewal.fee_payment_amount || '', onChange: handleChange, size: "small", variant: "outlined", fullWidth: true }),
                react_1.default.createElement(TextField_1.default, { name: "fee_payment_date", placeholder: (0, Lang_js_1.__)('Payment date'), value: renewal.fee_payment_date || '', onChange: handleChange, size: "small", variant: "outlined", fullWidth: true })))) : (react_1.default.createElement("span", { className: "status-ok" },
            (0, Lang_js_1.__)('You paid your ministerial renewal fee of'),
            " $",
            renewal.fee_payment_amount,
            " ",
            (0, Lang_js_1.__)('via'),
            " ",
            renewal.fee_payment_method,
            " ",
            (0, Lang_js_1.__)('on'),
            " ",
            formatDate((_b = renewal.fee_payment_date) !== null && _b !== void 0 ? _b : ''),
            " ",
            (0, Lang_js_1.__)('and may proceed with your renewal form'),
            "."))));
}
exports.default = FeePaymentStatus;
